import sendEmailPassword from '../../models/User/sendEmailPassword'
import { toast } from 'react-toastify'
import Toast from '../../containers/Toast'
import React from 'react'
import i18n from '../../i18n'
import { Mixpanel } from '../../utils/Mixpanel'

export default function(values: any) {
  sendEmailPassword(values.email)
    .then(() => {
      Mixpanel.track('Password Recovery Completed', {
        'Password Recovery Email': values.email,
      })

      toast(
        <Toast.Success>
          {i18n.t('OUT_4234_message_has_been_sent')}
        </Toast.Success>,
        {
          autoClose: 5000,
          className: 'success-background',
          containerId: 'Main',
          toastId: 'OUT_4234_message_has_been_sent',
        },
      )
    })
    .catch(e => {
      Mixpanel.track('Password Recovery Failed', {
        'Password Recovery Internet Active?': true,
        'Password Recovery Email': values.email,
      })

      toast(<Toast.Error>{i18n.t('errStatus_8')}</Toast.Error>, {
        autoClose: 5000,
        className: 'error-background',
        containerId: 'Main',
        toastId: 'errStatus_8',
      })
    })
}
